/* eslint-disable */
export default {
  status: '상태',
  acceptQueueCalls: '통화 큐 전화 받기',
  callQueueDisabledReason: '이 설정은 회사 관리자가 관리합니다.',
  callQueueManagement: '큐 관리',
} as const;

// @key: @#@"status"@#@ @source: @#@"Status"@#@
// @key: @#@"acceptQueueCalls"@#@ @source: @#@"Accept call queue calls"@#@
// @key: @#@"callQueueDisabledReason"@#@ @source: @#@"This setting is managed by your company administrator."@#@
// @key: @#@"callQueueManagement"@#@ @source: @#@"Manage queues"@#@
